import React from "react";

const AddCategory = () => {
  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightNewCategory"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Client</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="form-label">Name</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea type="text" className="form-control" />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary d-flex mt-3 me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary d-flex mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
